import { mergeStyles } from '@bulknutrients/bulk-shared-lib/utils';
import type { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

function openAncestorDetails(target: HTMLElement | null) {
  if (!target) return;

  const openStack: HTMLDetailsElement[] = [];
  let current = target.closest('details');

  while (current) {
    openStack.unshift(current);
    current = current.parentElement?.closest(
      'details'
    ) as HTMLDetailsElement | null;
  }

  openStack.forEach((details) => {
    details.open = true;
  });
}

export function ScrollLink({
  children,
  id,
  className,
  ...props
}: {
  children: ReactNode;
  id: string;
  className?: string;
} & Record<string, any>): ReactElement {
  const style = 'bg-inherit border-none p-0 text-start';

  return (
    <button
      className={mergeStyles(className ?? '', twMerge([style, 'clickable']))}
      onClick={() => {
        const target = document.getElementById(id);
        if (!target) return;

        if (target.closest('details')) {
          openAncestorDetails(target);
        }

        requestAnimationFrame(() =>
          target.scrollIntoView({ behavior: 'smooth' })
        );
      }}
      {...props}
    >
      {children}
    </button>
  );
}
